<flx-resources-page
  [showCustomActions]="true"
  class="h-full"
  pageTitle="Failed Process Start"
>
  <!-- The filters wrap under each other once the header's action line can't hold them side by side. -->
  <form
    [formGroup]="exceptionsFilterFG"
    class="flex flex-wrap items-center gap-2"
    flxResourcePageFirstAction
  >
    <flx-select
      [hasClear]="true"
      [hasSearch]="true"
      (filterChange)="processFilter$.next($event)"
      class="flx-ds w-64 min-w-0"
      formControlName="definitionName"
      placeholder="Filter by process definition"
    >
      @for (process of filteredApplicationProcesses(); track process.id) {
        <flx-select-option [value]="process">
          {{ process.resourceName }}
        </flx-select-option>
      }
    </flx-select>
    <div
      [formGroup]="dateRangeGroupFG"
      class="flex items-center gap-2"
    >
      <p-datepicker
        [defaultDate]="startTime"
        [showTime]="true"
        [showIcon]="true"
        [showClear]="true"
        class="flx-ds"
        dateFormat="dd M yy, "
        iconDisplay="input"
        formControlName="startDate"
        placeholder="From date"
      ></p-datepicker>
      <span> - </span>
      <p-datepicker
        [defaultDate]="endTime"
        [showTime]="true"
        [showIcon]="true"
        [showClear]="true"
        class="flx-ds"
        dateFormat="dd M yy, "
        iconDisplay="input"
        formControlName="endDate"
        placeholder="To date"
      ></p-datepicker>
    </div>
  </form>

  <button
    (click)="refresh()"
    class="flx-ds secondary"
    flxButton
    icon="center"
    pTooltip="Refresh"
    tooltipPosition="bottom"
    tooltipStyleClass="flx-prime-tooltip"
    data-testId="refresh-list-button"
    flxResourcePageLastAction
    aria-label="Refresh"
  >
    <i
      class="ph ph-arrow-clockwise"
      flxIcon
    ></i>
  </button>

  <ng-container ngProjectAs="[flxResourcesPageBody]">
    <flx-resources-grid
      [tableDef]="exceptionsTableColumns"
      [inputGridOptions]="gridOptions()"
      [rowClickEnabled]="true"
      [searching]="
        !!(
          exceptionsFilterFG.value.definitionName ||
          dateRangeGroupFG.value.startDate ||
          dateRangeGroupFG.value.endDate
        )
      "
      (gridReady)="onGridReady($event)"
      (rowClick)="navigateToException($event)"
      class="h-full"
      emptyMsg="No failed process starts"
      emptyMsgDescription="Process starts that failed with an exception are listed here to help you debug them."
      emptyMsgIcon="ph ph-tree-structure"
      emptyMsgItems="exceptions"
    ></flx-resources-grid>
  </ng-container>
</flx-resources-page>
